import { createColDefs } from '@fortem-monorepo/react-ag'
import { TimeCellRenderer } from '@fortem-monorepo/react-ag'
import { Logs } from '@fortem-monorepo/web-sdk'

import { ScheduledTaskStatusCellRenderer } from '@/ag-grid/cell-renderers/ScheduledTaskStatusCellRenderer'

export const otherColDefs = createColDefs<Logs.ScheduledTask>([
  { field: 'id', hide: true, resizable: true },
  {
    field: 'status',
    width: 100,
    cellRenderer: ScheduledTaskStatusCellRenderer,
  },
  { field: 'date', width: 100, hide: true, sortable: true },
  {
    field: 'upload_datetime_utc',
    headerName: 'Started At',
    width: 175,
    cellRenderer: TimeCellRenderer,
  },
  {
    field: 'update_datetime_utc',
    headerName: 'Finished At',
    width: 175,
    cellRenderer: TimeCellRenderer,
  },
  { field: 'output', resizable: true },
])
